import React from 'react';

export const getTooltipContent = ({ canChangeStatus, tooltipData }) => {
  // Case 1: Has metadata to display
  if (tooltipData?.length > 0) {
    return (
      <div style={{ padding: '8px 0' }}>
        {tooltipData.map(item => (
          <div key={item.id} style={{ margin: '4px 0' }}>
            <strong>{item.key}:</strong> {String(item.value)}
          </div>
        ))}
      </div>
    );
  }

  // Case 2: Can't change status
  if (canChangeStatus === false) {
    return 'You need to be a member of the workspace and have admin, owner, or special permissions to change the status';
  }

  // Case 3: Default fallback
  return 'Click to change';
};
